module.exports = __webpack_public_path__ + "static/img/14.3f074e08.png";